import React from "react";
import Udesk from "Udesk";
import { Avatar } from "udesk-ui";

export default React.memo<{align: 'right' | 'left'}>(({align}) => {
    return (
        <Avatar src={align === 'left' ? '/static/images/robot.png' : (Udesk.data.init?.user?.headPortraitUrl || '/static/images/agent.png')}/>
    );
});